let _el: HTMLVideoElement | null = null;

export const setCameraVideoElement = (el: HTMLVideoElement | null) => {
  _el = el;
};

export const getCameraVideoElement = (): HTMLVideoElement | null => _el;
